import useUrl from "hooks/useUrl"
import { isEmpty } from "rambdax"

export function ShopModuleSharingPhotoPC({ item }) {
  const { getPublicUrl } = useUrl()

  if (isEmpty(item?.jsonConfig) || isEmpty(item?.jsonConfig?.rows)) {
    return null
  }

  const sharingPhotoList = item.jsonConfig.rows?.sort(
    (a, b) => a.priority - b.priority,
  )

  const openURL = (record) => {
    if (!record.pageUrl) {
      return
    }
    window.open(record.pageUrl)
  }

  return (
    <>
      <div className="sharingPhoto-wrap">
        <div className="sharingPhoto-ul">
          {sharingPhotoList.map((item, index) => (
            <div
              key={index}
              className="sharingPhoto-li"
              onClick={() => openURL(item)}
            >
              <img alt="" src={getPublicUrl(item.pageIcon)} />
            </div>
          ))}
        </div>
      </div>
      <style jsx>{`
        .sharingPhoto-li {
          width: 100%;
          text-align: center;
          cursor: pointer;
        }

        .sharingPhoto-li img {
          max-width: 100%;
        }
      `}</style>
    </>
  )
}
